var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_vm._v(" perfil ")])
}
var staticRenderFns = []

export { render, staticRenderFns }